import React from "react";
import { Link, useNavigate } from "react-router-dom";

function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="main-wrapper" style={{ textAlign: "center", marginTop: "100px" }}>
      <div className="error-box">
        <div className="error-img"></div>
        <h3 className="h2 mb-3">Oops, something went wrong</h3>
        <h4 className="h2 mb-1">403 - Access Denied</h4>
        <p>You do not have permission to access this page.</p>
        <Link className="btn btn-primary" onClick={() => navigate(-1)}>
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}

export default Unauthorized;
